import apiClient from "../../utils/apiclient";

export const createtask = async (
   reqBody: {
     task_en: string;
     credit_points: string;
     duration: string;
     require_task_approval: boolean;
     bonus_point: string;
     bonus_duration: string;
     task_type_en: string;
     intro_poster:string[];
     task_icon: string | string[];
     task_type_hi:string
     
  
    //  task_instructions: [
     
    //         task_instruction: string,
    //         task_instruction_img: string
        
    //   ]
     questions: Array<{
       question_en: string;
       question_hi: string;
       points:string
       sample_picture:string
       question_no: number;
       options: { option_value_en: string; option_value_hi: string }[];
       correct_option: string;
       hint: { content_type_en: string; content_type_hi: string };
       instructions: {
         step_number: number;
         step_text_en: string;
         step_text_hi: string;
         step_icon: string;
       }[];
     }>;
   },
   token: string
 ) => {
   return await apiClient.post("/admin/task", reqBody, {
     headers: {
       Authorization: `Bearer ${token}`,
     },
   });
 };
 export const duplicatetask = async (
   reqBody: {
     task_en: string;
     credit_points: string;
     duration: string;
     require_task_approval: boolean;
     bonus_point: string;
     bonus_duration: string;
     task_type_en: string;
     intro_poster:string[];
     task_icon: string | string[];
     task_type_hi:string
     
  
    //  task_instructions: [
     
    //         task_instruction: string,
    //         task_instruction_img: string
        
    //   ]
     questions: Array<{
       question_en: string;
       question_hi: string;
       points:string
       sample_picture:string
       question_no: number;
       options: { option_value_en: string; option_value_hi: string }[];
       correct_option: string;
       hint: { content_type_en: string; content_type_hi: string };
       instructions: {
         step_number: number;
         step_text_en: string;
         step_text_hi: string;
         step_icon: string;
       }[];
     }>;
   },
   token: string
 ) => {
   return await apiClient.post("/admin/task", reqBody, {
     headers: {
       Authorization: `Bearer ${token}`,
     },
   });
 };
 

 export const edittasks = async (
   reqBody: {
     task_en: string;
     credit_points: string;
     duration: string;
     require_task_approval: boolean;
     bonus_point: string;
     bonus_duration: string;
     task_type_en: string;
     intro_poster:string[];
     task_icon: string | string[];
     task_type_hi:string
     
  
    //  task_instructions: [
     
    //         task_instruction: string,
    //         task_instruction_img: string
        
    //   ]
     questions: Array<{
       question_en: string;
       question_hi: string;
       points:string
       sample_picture:string
       question_no: number;
       options: { option_value_en: string; option_value_hi: string }[];
       correct_option: string;
       hint: { content_type_en: string; content_type_hi: string };
       instructions: {
         step_number: number;
         step_text_en: string;
         step_text_hi: string;
         step_icon: string;
       }[];
     }>;
   },
   token: string
 ) => {
   return await apiClient.post("/admin/task/edit_task", reqBody, {
     headers: {
       Authorization: `Bearer ${token}`,
     },
   });
 };
 

 export const getalllocations=async()=>{
  return await apiClient.get('/city/distinctcity',{
   
  })
}

export const uploadimagetask = async (formData: FormData, token: string) => {
   const headers = {
     Authorization: `Bearer ${token}`,
     "Content-Type": "multipart/form-data",
   };
 
   const response = await apiClient.post("/answer/upload", formData, { headers });
   return response.data; 
 };



 export const fetchTaskDetails = async (
  taskId: string,
  token: string
) => {
  return await apiClient.get(`/task/fetch-task-details/${taskId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
     
    },
  });
};

 
